export function campaignChargesValidations(value) {

    let errors = {};
    if (!value.goal) {
        errors.goal = 'Goal is required';
    }
    if (!value.value) {
        errors.value = 'Goal charges is required';
    }

    return errors;


}

export function interestValidations(value) {
    let errors = {};
    if (!value.name) {
        errors.name = 'Name is required';
    }
    return errors;


}